import { nanoid } from "nanoid";
import { joinLines } from "../../helpers/exportHelpers";
import { IExportArtifact } from "../ExportArtifacts/IExportArtifact";
import { IModelInfo } from "../ModelInfos/IModelInfo";

export function generateGoStruct(models: IModelInfo[]): IExportArtifact[] {
    const artifacts: IExportArtifact[] = [];
    const tab = "    ";
    const line = "\r\n";

    for (const model of models) {
        const properties = model.members.map(x => `${tab}${x.name} ${x.type.name}`);
        //const usings = model.imports.map(x => `using ${x};`)
        const fileContent = joinLines(line, [
            `type ${model.name} struct {`,
            ...properties,
            `}`
        ]);

        const artifact: IExportArtifact = {
            id: nanoid(),
            exportId: nanoid(),
            created: new Date(),
            fileName: `${model.name}.go`,
            content: fileContent
        };
        artifacts.push(artifact);
    }

    return artifacts;
}
